export const URLESTADOCLIENTE = 'https://seo.yoseomk.vps-100.netricahosting.com/api/edit-client'
export const URL_EMPLEADOS_LG = 'https://seo.yoseomk.vps-100.netricahosting.com/api/empleados-lg-client'

//export const URLESTADOCLIENTE = 'http://localhost:5000/api/edit-client'
//export const URL_EMPLEADOS_LG = 'http://localhost:5000/api/empleados-lg-client'
